export const SIGNATURE_CREATION_ERROR_TYPES = {
  VERIFICATION_TOKEN_NOT_VALID: 'VERIFICATION_TOKEN_NOT_VALID',
};
